module.exports = __webpack_public_path__ + "v-blue-77c6a4e4.svg";